export class User {
  username: string;
  password: string;
  language_choice: string;
}
